import DashboardIcon from "../assets/icons/dashboard.svg";
import UsersIcon from "../assets/icons/users.png";
import PatientIcon from "../assets/icons/patient.png";
import HospitalIcon from "../assets/icons/hospital.png";
import FileIcon from "../assets/icons/fileIcon.png";
import BellIcon from "../assets/icons/bell.png";
import QnaIcon from "../assets/icons/qna.png";
import { on } from "events";

const sidebar_menu = [
  {
    id: 1,
    icon: UsersIcon,
    path: "users",
    title: "사용자 관리",
    // auth: "Admin",
  },
  {
    id: 2,
    icon: UsersIcon,
    path: "user-management",
    title: "밤토리 사용자 관리",
    // auth: "Superadmin",
  },
  {
    id: 3,
    icon: HospitalIcon,
    path: "hospital",
    title: "병원 관리",
  },
  {
    id: 4,
    icon: PatientIcon,
    path: "patient",
    title: "환자 정보 관리",
  },
  {
    id: 5,
    icon: FileIcon,
    path: "gosi",
    title: "고시 관리",
  },
  {
    id: 6,
    icon: BellIcon,
    path: "notice",
    title: "공지 관리",
  },
  {
    id: 7,
    icon: QnaIcon,
    path: "patient-community",
    title: "환자 커뮤니티(Q&A)",
  },
  // {
  //   id: 7,
  //   icon: QnaIcon,
  //   path: null,
  //   onClick: () => {
  //     //새창 띄우기
  //     window.open("/admin/qna", "popupWindow", "width=500,height=400,top=100,left=200,resizable=yes,scrollbars=yes");
  //   },
  //   title: "환자 커뮤니티(Q&A)",
  // },
];

export default sidebar_menu;
